import { Controller } from "@hotwired/stimulus"

// The dock of homes on pages that are not a dashboard (the Feed, Your page). On a dashboard the dock is
// positioned by CSS inside .assistant-main; here it is fixed, and this centres it on the page region
// as the dashboard's is, whatever width the sidebar next to it has. It sits at the foot by CSS.
export default class extends Controller {
  connect() {
    this._place = () => {
      const region = document.querySelector(".assistant-main")
      if (!region) return
      const box = region.getBoundingClientRect()
      this.element.style.setProperty("--dashboard-rail-center", `${box.left + box.width / 2}px`)
    }
    this._place()
    this._observer = new ResizeObserver(this._place)
    const region = document.querySelector(".assistant-main")
    if (region) this._observer.observe(region)
    window.addEventListener("resize", this._place)
    // The sidebar opening or closing moves the region without resizing the window.
    document.addEventListener("transitionend", this._place, true)
  }

  disconnect() {
    this._observer?.disconnect()
    window.removeEventListener("resize", this._place)
    document.removeEventListener("transitionend", this._place, true)
  }
}
